import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ClockIcon, BookOpenIcon, WalletIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  const handleBuyClick = () => {
    trackAddToCart();
  };
  return <section id="offer-cta" className="px-4 py-20 md:py-28 bg-midnight-900/50" data-id="element-114">
      <div className="max-w-2xl mx-auto" data-id="element-115">
        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="mb-12" data-id="element-116">
          <img src="https://cdn.magicpatterns.com/uploads/4Yazgb7vTHxJ24STkYciEW/The_0_Tax_Rescue_Guide_Product_Image.png" alt="The $0 Tax Rescue Guide shown on laptop, tablet, and phone screens" className="w-full h-auto rounded-lg" data-id="element-117" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="relative" data-id="element-118">
          {/* Ambient glow behind card */}
          <div className="absolute inset-0 -m-4 rounded-2xl pointer-events-none" style={{
          background: 'radial-gradient(ellipse at center, rgba(246,185,59,0.08) 0%, transparent 70%)'
        }} aria-hidden="true" data-id="element-119" />

          <div className="relative bg-midnight-800 border-2 border-rescue-gold/30 rounded-xl p-8 md:p-10 text-center" data-id="element-120">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-121">
              Get the Full $0 Tax Rescue Guide
            </h2>
            <p className="font-body text-gray-400 mb-8 max-w-lg mx-auto" data-id="element-122">
              Stop the clock, skip the fees, and get your life back for less
              than the cost of a pizza.
            </p>

            {/* CTA Button */}
            <a href="https://www.helpyourselfguides.com/cart/51449100796194:1" target="_blank" rel="noopener noreferrer" role="button" onClick={() => handleBuyClick()} className="inline-block w-full max-w-md bg-rescue-gold text-midnight-950 font-body font-bold text-lg md:text-xl px-8 py-4 rounded-lg transition-all duration-200 hover:bg-amber-400 hover:shadow-lg hover:shadow-rescue-gold/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-rescue-gold focus-visible:ring-offset-2 focus-visible:ring-offset-midnight-800 uppercase tracking-wide mb-8" data-id="element-123">
              Download the Rescue Guide Now
            </a>

            {/* What's included - brief */}
            <ul className="text-left max-w-sm mx-auto space-y-3 mb-10" data-id="element-124">
              <li className="flex items-center gap-3" data-id="element-125">
                <CheckIcon className="w-4 h-4 text-rescue-green flex-shrink-0" aria-hidden="true" data-id="element-126" />
                <span className="font-body text-sm text-gray-300" data-id="element-127">
                  The $0 Tax Rescue Guide (PDF)
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-128">
                <CheckIcon className="w-4 h-4 text-rescue-green flex-shrink-0" aria-hidden="true" data-id="element-129" />
                <span className="font-body text-sm text-gray-300" data-id="element-130">
                  60-Minute Filing Sprint Checklist
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-131">
                <CheckIcon className="w-4 h-4 text-rescue-green flex-shrink-0" aria-hidden="true" data-id="element-132" />
                <span className="font-body text-sm text-gray-300" data-id="element-133">
                  "Plain English" Translation Key
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-134">
                <CheckIcon className="w-4 h-4 text-rescue-green flex-shrink-0" aria-hidden="true" data-id="element-135" />
                <span className="font-body text-sm text-gray-300" data-id="element-136">
                  "I Can't Pay" Protocol
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-137">
                <CheckIcon className="w-4 h-4 text-rescue-green flex-shrink-0" aria-hidden="true" data-id="element-138" />
                <span className="font-body text-sm text-gray-300" data-id="element-139">
                  Audit-Proof Category Map
                </span>
              </li>
            </ul>

            {/* Price */}
            <div className="mb-0" data-id="element-140">
              <div className="flex items-center justify-center gap-3 mb-2" data-id="element-141">
                <span className="font-heading text-2xl md:text-3xl font-bold text-gray-500 line-through" data-id="element-142">
                  $19.99
                </span>
                <span className="font-body text-sm font-bold uppercase tracking-wide bg-rescue-green/15 text-rescue-green px-3 py-1 rounded-full" data-id="element-143">
                  Save 65%
                </span>
              </div>
              <span className="font-heading text-6xl md:text-7xl font-bold text-rescue-gold" data-id="element-144">
                $6.99
              </span>
            </div>

            {/* Trust signals */}
            <p className="font-body text-sm text-gray-500 mt-5" data-id="element-145">
              One-time payment. Instant digital access. No hidden upsells.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}